import * as Rx from 'rxjs';

class UiManagerService {
  private currentlyTour$ = new Rx.BehaviorSubject(null);
  private isModalOpen = new Rx.BehaviorSubject(false);

  public setCurrentlyTour(name: string) {
    this.currentlyTour$.next(name);
  }

  public setIsModalOpen(state: boolean) {
    this.isModalOpen.next(state);
  }

  public getCurrentlyTour() {
    return this.currentlyTour$;
  }

  public getIsModalOpen() {
    return this.isModalOpen;
  }
}

export const uiManagerService = new UiManagerService();
